import React from "react";
import ReactDOM from "react-dom";
import webservice from "../../API/webservice.js";

class WizardItemGbPostCodeSearch extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			postCode: "",
			postCodeIds: [],
			addresses: null,
			selectedAddress: null,
			selectedAddressId: null,
			showDropdown: true,
			showAddressDiv: false,
			showError: false,
			firstError: false,
			formSubmitted: false,
			timeout: null,
			errorMsg: "[]"
		};

		this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.selectAddress = this.selectAddress.bind(this);
		this.removeAddressDiv = this.removeAddressDiv.bind(this);
		this.findAdressesFromPostCodeId = this.findAdressesFromPostCodeId.bind(this);
	}

	componentWillMount() {
		if (typeof document !== "undefined") {
			document.addEventListener("click", this.handleClickOutsideDropdown, false);
		}
	}

	componentWillUpdate(props) {
		if (props.currentAnswerError && !this.state.firstError) {
			this.handleSubmit();
		}
	}

	componentWillUnmount() {
		document.removeEventListener("click", this.handleClickOutsideDropdown, false);
	}

	handleChange(e) {

		this.setState({ postCode: e.target.value });

		if (this.state.timeout) clearTimeout(this.state.timeout);
		if (e.target.value.length >= 5) {
			this.state.timeout = setTimeout(() => {
				//search function
				this.handleSubmit();
			}, 500);
		}
	}

	removeAddressDiv() {
		this.setState({ showAddressDiv: false, showDropdown: true });
		ReactDOM.findDOMNode(this.refs.textInput).focus();
	}

	selectAddress(e) {
		e.preventDefault();

		let url = `/api/wizard/gbgetaddressdetails?addressId=${e.target.id}`;
		let json = webservice.postCodeService(url);
		const adrText = e.target.value;

		json.then(response => {
			const adrDataString = JSON.stringify(response.data.Data);

			const answerObject = {
				adrText: adrText,
				adrDataString: adrDataString
			};

			const answer = JSON.stringify(answerObject);

			this.props.submitAnswer(answerObject);
			this.setState({ selectedAddress: adrText, showAddressDiv: true, showDropdown: false, showError: false });

		}).catch(error => {
			this.setState({ showAddressDiv: false, showDropdown: false, showError: true, errorMsg: "Error" });
		});

	}

	handleSubmit(e) {
		if (e) {
			e.preventDefault();
		}

		this.setState({ firstError: true });

		let url = `/api/wizard/gbpostcodesearch?postcode=${this.state.postCode}`;
		let json = webservice.postCodeService(url);

		json.then(response => {
			this.setState({ addresses: response.data.Data, showAddressDiv: false, showDropdown: true, showError: false });
		}).catch(error => {
			this.setState({
				showAddressDiv: false,
				showDropdown: false,
				showError: true,
				errorMsg: error.response.data.Message
			});
		});
	}

	findAdressesFromPostCodeId(postCodes) {
		let that = this;
		let addresses = [];
		postCodes.forEach(function (val, i) {

			const APIkey = 'JU99-TJ87-TR29-ZW39';
			let url = `https://api.addressy.com/Capture/Interactive/Find/v1.00/json3.ws?key=${APIkey}&Container=${val}&Countries=GB&language=en-gb`;
			let json = webservice.postCodeService(url);
			json.then(response => {
				response.data.Items.forEach(function(val, i) {
					addresses.push(val);
				});
				that.setState({ addresses: addresses, showAddressDiv: false, showDropdown: true, showError: false });
			});
		});
	}

	handleClickOutsideDropdown(e) {
		if (this.state.addresses && this.state.showDropdown) {
			if (!ReactDOM.findDOMNode(this.refs.dropDown).contains(e.target)) {
				this.setState({ showDropdown: false });
			}
		}
	}

	render() {
		const useTag = '<use xlink:href="/dist/svgsprite/icons.svg#Search_16x16"></use>';

		return (
			<div className="wizard-item wizard-item__single-line wizard-item__GB-post-code">
				<form id="post-code-form" onSubmit={this.handleSubmit}>
					<input type="text" ref={"textInput"} placeholder={this.props.data.PlaceholderText} onFocus={this.handleChange} onChange={this.handleChange} value={this.state.postCode} />
					<button type="submit">
						<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" dangerouslySetInnerHTML={{ __html: useTag }} />
					</button>
					{this.state.showError &&
						<div className="error">{this.state.errorMsg}</div>
					}
					{this.state.showAddressDiv &&
						<input type="text" readOnly onClick={this.removeAddressDiv} value={this.state.selectedAddress} className="address" data-trackingid={this.props.data.QuestionTrackingId} />
					}

					{(this.state.addresses && this.state.showDropdown) &&
						<ul ref={"dropDown"}>
							{this.state.addresses.map((adr, idx) => {
								return (
									<li key={idx} value={adr.Text} >
										<button type="button" value={adr.Text + ', ' + adr.Description} id={adr.Id} className={(adr.Text == this.state.selectedAddress) ? 'bold' : ''} onClick={this.selectAddress}>{adr.Text + ', ' + adr.Description}</button>
									</li>
								)
							})
							}
						</ul>
					}

				</form>
			</div>
		)
	}
}

export default WizardItemGbPostCodeSearch;